/**
 * useNd — KPI 4 Distribution Numérique
 * GET /api/v1/market/kpis/numeric-distribution
 * spec_kpis.md §6
 */
import { useQuery } from '@tanstack/react-query';
import { fetchKpi } from '../../lib/api';
import type { KpiApiResponse, NdData, MarcheQueryParams } from '../../types/marche.types';

export function useNd(
  params?: MarcheQueryParams,
  options?: { enabled?: boolean; includeRef4w?: boolean; includeRefW1?: boolean; includeRefSwly?: boolean },
) {
  const includeRef4w   = options?.includeRef4w   ?? false;
  const includeRefW1   = options?.includeRefW1   ?? false;
  const includeRefSwly = options?.includeRefSwly ?? false;
  const effectiveParams: MarcheQueryParams | undefined =
    includeRef4w || includeRefW1 || includeRefSwly
      ? {
          ...params,
          ...(includeRef4w   ? { include_ref4w:    true } : {}),
          ...(includeRefW1   ? { include_ref_w1:   true } : {}),
          ...(includeRefSwly ? { include_ref_swly: true } : {}),
        }
      : params;
  return useQuery<KpiApiResponse<NdData>>({
    queryKey: ['market', 'numeric-distribution', params, { includeRef4w, includeRefW1, includeRefSwly }],
    queryFn: () => fetchKpi<NdData>('numeric-distribution', effectiveParams),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
